
export function relatorio(dados, meta) {
    let conteudo = [];
    console.log('dados', dados)


    return conteudo;
}
const relatorioConfig = {
    directCode: relatorio,
    descricao: "Relatório Resumo Gemas por periodo",
    nome: "Relatório Resumo Gemas",
    tipoModelo: "sSCy71ONYFEwlGVDK4kKMultiplo",
    publico: true
}
export default relatorioConfig